import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const NameWrapper = styled('div')({
  display: 'flex',
  alignItems: 'start',
  gap: '6px',
});

export const PackageName = styled('span')({
  fontSize: '14px',
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const PackageId = styled('span')<{ alignLeft: boolean }>(({ alignLeft }) => ({
  marginLeft: alignLeft ? '24px' : '6px',
  fontSize: '12px',
  fontWeight: '600',
}));
